export const INSERT_ORDER_REQUEST = "INSERT_ORDER_REQUEST";
export const INSERT_ORDER_SUCCESS = "INSERT_ORDER_SUCCESS";
export const INSERT_ORDER_FAILURE = "INSERT_ORDER_FAILURE";